<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">

      <v-form ref="form" @submit.prevent="save" v-model="formValid" lazy-validation>
        <EventoInscricaoForm v-model="item"/>
      </v-form>

    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" @click="$emit('input', false)" :disabled="loading">Cancelar</v-btn>
      <v-btn color="primary" @click="save" :disabled="!formValid || loading">Salvar</v-btn>
    </v-card-actions>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>    
</v-dialog>
</template>

<script>
import EventoInscricaoForm from "../forms/EventoInscricaoForm";
import {create, update} from "../../../api/eventoInscricao";
import {ApiError} from "../../../api/core";

export default {
  name: "CreateEditEventoInscricaoDialog",
  components: {EventoInscricaoForm},
  props: ['value','item'],
  data () {
    return {
      formValid: false,
      loading: false,
    }
  },
  computed: {
    getTitle() {
      return this.item?.id ? 'Editar Inscrição' : 'Adicionar Inscrição'
    }
  },
  methods: {
    toJsonIds(items) {
      if (!Array.isArray(items)) return JSON.stringify([]);
      return JSON.stringify(
        items
          .map(item => Number(item?.id))
          .filter(id => Number.isFinite(id) && id > 0)
      );
    },
    buildPayload() {
      return {
        ...this.item,
        cronograma: this.toJsonIds(this.item?.cronogramaInscricao),
        ofertaDemanda: this.toJsonIds(this.item?.ofertaDemanda),
      };
    },
    async validateStatusChange(payload) {
      const eventoPago = payload?.tipoAcessoEventoEdicao === 'P';
      const statusAprovado = payload?.status === 'A';
      const linkPagamentoVazio = !String(payload?.linkPagamento || '').trim();

      if (!eventoPago || !statusAprovado || !linkPagamentoVazio) {
        return true;
      }

      const result = await this.$swal({
        title: 'O link de pagamento ainda não foi enviado para esta inscrição.',
        html: 'Deseja realmente aprovar essa inscrição?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, quero aprovar',
      });

      return result.isConfirmed === true;
    },
    async save() {
      try {
        this.loading = true;
        if(this.$refs.form.validate()) {
          const payload = this.buildPayload();
          if(this.item.id) {
            const podeSalvar = await this.validateStatusChange(payload);
            if (!podeSalvar) {
              return;
            }
            await update(this.item.id, payload);
          } else {
            await create(payload)
          }
          this.$emit('input', false);
          this.$emit('onSave');
          this.$toast.success(`Inscrição ${this.item.id ? 'atualizada' : 'criada'} com sucesso.`, {
            timeout: 3000
          })
        }
      } catch (err) {
        if(err instanceof ApiError) {
          this.$toast.error(err.message, {
           timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível ${this.item.id ? 'atualizar' : 'realizar'} a Inscrição.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>

<style scoped>

</style>